var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex col w-100 justify-content-end"},_vm._l((_vm.colors),function(color){return _c('p',{key:color.name,class:("task task-" + (color.state))},[_c('span',[_vm._v(_vm._s(color.name))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }